import React, { useState } from 'react';
import { Wheel } from 'react-custom-roulette';
import './Ruleta.css';

const truncar = (texto, max = 18) =>
  texto.length > max ? texto.slice(0, max - 1) + '…' : texto;

// 3 colores que se alternan — nunca dos iguales juntos
const COLORES = ['#f000a8', '#07eaf1', '#f5a623'];

const Ruleta = ({ opciones, alTerminar, bloqueado, alSaltearTodo, onSorteoTotalConfirmado, yaGiro }) => {
  const [mustSpin, setMustSpin]       = useState(false);
  const [prizeNumber, setPrizeNumber] = useState(0);
  const [saltarAnim, setSaltarAnim]   = useState(false);
  const [resumenSalteo, setResumenSalteo] = useState(null);

  const data = opciones.map((opt, i) => ({
    option: truncar(opt),
    fullOption: opt,
    style: {
      backgroundColor: COLORES[i % COLORES.length],
      textColor: 'black',
    }
  }));

  const handleSpinClick = () => {
    if (mustSpin || bloqueado) return;
    const newPrizeNumber = Math.floor(Math.random() * data.length);
    setPrizeNumber(newPrizeNumber);

    if (saltarAnim) {
      alTerminar(data[newPrizeNumber].fullOption);
    } else {
      setMustSpin(true);
    }
  };

  const handleSaltearTodo = () => {
    if (!alSaltearTodo) return;
    const resultado = alSaltearTodo();
    if (resultado) setResumenSalteo(resultado);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>

      {/* Modal resumen cuando se saltea todo */}
      {resumenSalteo && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', zIndex: 99999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          onClick={() => setResumenSalteo(null)}>
          <div style={{ background: '#0a0f19', border: '2px solid #00f2ff', borderRadius: '16px', padding: '32px 40px', maxWidth: '420px', width: '90%', textAlign: 'center' }}
            onClick={e => e.stopPropagation()}>
            <h2 style={{ color: '#00f2ff', margin: '0 0 20px', letterSpacing: '2px' }}>TU DRAFT</h2>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '24px' }}>
              <div style={{ background: '#1a2233', borderRadius: '8px', padding: '10px 16px', display: 'flex', justifyContent: 'space-between' }}>
                <span style={{ color: '#64748b' }}>Presupuesto</span>
                <span style={{ color: '#f5a623', fontWeight: 'bold' }}>{resumenSalteo.presupuesto}</span>
              </div>
              <div style={{ background: '#1a2233', borderRadius: '8px', padding: '10px 16px', display: 'flex', justifyContent: 'space-between' }}>
                <span style={{ color: '#64748b' }}>Formación</span>
                <span style={{ color: '#00f2ff', fontWeight: 'bold' }}>{resumenSalteo.formacion}</span>
              </div>
              <div style={{ background: '#1a2233', borderRadius: '8px', padding: '10px 16px', display: 'flex', justifyContent: 'space-between' }}>
                <span style={{ color: '#64748b' }}>Restricciones</span>
                <span style={{ color: '#f000a8', fontWeight: 'bold' }}>{resumenSalteo.cantidad}</span>
              </div>
              {(resumenSalteo.restricciones || []).map((r, i) => (
                <div key={i} style={{ background: '#1a2233', borderRadius: '8px', padding: '10px 16px', textAlign: 'left' }}>
                  <span style={{ color: '#e2e8f0' }}> {r.texto || r}</span>
                </div>
              ))}
            </div>
            <button onClick={() => {
                const res = resumenSalteo;
                setResumenSalteo(null);
                if (onSorteoTotalConfirmado) onSorteoTotalConfirmado(res);
              }}
              style={{ background: '#00f2ff', color: '#000', border: 'none', borderRadius: '50px', padding: '12px 32px', fontWeight: 'bold', fontSize: '1rem', cursor: 'pointer' }}>
              ¡Listo, a armar el equipo!
            </button>
          </div>
        </div>
      )}

      <Wheel
        mustStartSpinning={mustSpin}
        prizeNumber={prizeNumber}
        data={data}
        onStopSpinning={() => {
          setMustSpin(false);
          alTerminar(data[prizeNumber].fullOption);
        }}
        spinDuration={0.6}
        outerBorderColor="#ffffff"
        radiusLineColor="#000000"
        pointerProps={{ style: { filter: 'hue-rotate(-10deg) saturate(2) brightness(1.1)', transform: 'scale(1.1)' } }}
        fontSize={13}
      />

      <button className="boton-girar" onClick={handleSpinClick} disabled={mustSpin || bloqueado}>
        {mustSpin ? 'SORTEANDO...' : bloqueado ? 'ESPERE...' : 'GIRAR'}
      </button>

      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', justifyContent: 'center' }}>
        <button
          onClick={() => setSaltarAnim(v => !v)}
          disabled={mustSpin}
          style={{ background: 'transparent', border: `1px solid ${saltarAnim ? '#00f2ff' : '#334155'}`, color: saltarAnim ? '#00f2ff' : '#475569', borderRadius: '6px', padding: '5px 14px', fontSize: '0.72rem', cursor: 'pointer', letterSpacing: '1px', transition: '0.2s' }}>
          {saltarAnim ? ' Sin animación (activo)' : 'Saltear animación'}
        </button>

        {/* Si ya giró al menos una vez → solo "Saltear esta sección" (aleatorio sin animación) */}
        {yaGiro && alTerminar && (
          <button
            onClick={() => {
              const rand = opciones[Math.floor(Math.random() * opciones.length)];
              alTerminar(rand);
            }}
            disabled={mustSpin || bloqueado}
            style={{ background: 'transparent', border: '1px solid #64748b', color: '#64748b', borderRadius: '6px', padding: '5px 14px', fontSize: '0.72rem', cursor: 'pointer', letterSpacing: '1px' }}>
            ↩ Saltear sección
          </button>
        )}

        {/* Si NO giró todavía → mostrar "Sortear todo" */}
        {!yaGiro && alSaltearTodo && (
          <button
            onClick={handleSaltearTodo}
            disabled={mustSpin || bloqueado}
            style={{ background: 'transparent', border: '1px solid #f5a623', color: '#f5a623', borderRadius: '6px', padding: '5px 14px', fontSize: '0.72rem', cursor: 'pointer', letterSpacing: '1px', transition: '0.2s' }}>
            Sortear todo
          </button>
        )}
      </div>
    </div>
  );
};

export default Ruleta;